{% block sw_cms_block_acris_blog_subtitle %}
    <div class="sw-cms-block-acris-blog-subtitle">
        <slot name="column"></slot>
    </div>
{% endblock %}
